import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuItem as UserInfo, Message } from 'primeng/primeng';
import { SharedService } from './shared/shared.service';
import { Distance, RoleAccess, PageKey } from './shared/shared.model';
import { BaseComponent } from './shared/base.component';
import { MenuService } from './menu/menu.service';
import { MenuItem, Logo } from './menu/menu.model';
import { Theme } from './shared/shared.model';
import { CommunicationService } from './shared/communication.service';
import { TranslateService } from '@ngx-translate/core';
import { WoService } from './work-order/work-order.service';
import { SearchWorkOrder } from './work-order/work-order-models';
import { LoaderService } from './shared/loader.service';
import { Location } from '@angular/common';
import { LanguageCompEntity } from './admin/user/user.models';
import { AuthService } from '../authentication/auth.service';
import { SmsLogReceived } from './work-order/work-order-models';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FPTextChatPopupComponent } from './fp-text-chat/fp-textchat-popup.component';
import { SearchQuote } from './qo-work-order/qo-work-order-models';
import { QOWoService } from './qo-work-order/qo-work-order.service';

@Component({
    selector: 'app-layout',
    templateUrl: 'layout.component.html'
    // providers: [MenuService]
})

export class LayoutComponent extends BaseComponent implements OnInit {
    //globalInfo: GlobalInfo;
    detailedMenu: boolean = false;
    // users: User[] = [];
    items: UserInfo[];
    static _menus: MenuItem[] = [];
    selectedMenu: MenuItem;
    // selectedMenu:MenuItem[] = [];
    notifications: Message[] = [];
    userDisplayName: string;
    userEmail: string;
    companyLogo: string;
    logo: Logo = new Logo();
    frmSkill: FormGroup;
    frmLang: FormGroup;
    frmType: FormGroup;
    version: string;
    companyLanguage: LanguageCompEntity[] = [];
    settingid: number[];
    taxSettingId: number[];
    type: boolean = false;
    IsOpensms: boolean = false;
    IsNotification: boolean = false;
    smsmsg: SmsLogReceived;
    woName: string;
    qoName: string;
    ReadedCount: number;
    openEmailpopup: boolean = false;
    EmailJob: any;
    @Output() getSms = new EventEmitter();
    isSame: boolean = false;
    pmwoName: string;
    interval: any;
    woStr: string;
    qoStr: string;
    pmwoStr: string;
    distance: string;
    Tax: boolean;
    ifinhouse: number;
    smobinav: boolean = false;
    textChat: boolean = false;
    smslogReceived: SmsLogReceived[] = [];
    emaillogReceived: SmsLogReceived[] = [];
    ReadedEmailCount: number;
    IsQUoteEnabled: boolean = false;
    @Output() done = new EventEmitter();
    @Output() open = new EventEmitter();
    fptextChat: FPTextChatPopupComponent;
    //openQuoteEmailpopup: any;
    istextchat: boolean = false;
    chatCount: number = 0;
    CompanyUniqueId: string;
    rights: RoleAccess;

    constructor(private menuService: MenuService, private location: Location, private router: Router, private datePipe: DatePipe,
        protected formBuilder: FormBuilder, protected woService: WoService, public sharedService: SharedService, private communicationService: CommunicationService,
        public translate: TranslateService, private loaderservice: LoaderService, private authService: AuthService, private _DomSanitizationService: DomSanitizer) {
        super(sharedService, translate);
        this.sharedService.notification.subscribe(data => {
            this.notifications.push(data);
        });
        this.communicationService.Message$.subscribe(message => {
            this.notifications.push(message);
        });
        this.menuService.getAllCompanyLanguage(this.globalInfo().CompanyId).subscribe(res => {
            this.companyLanguage = res;
            // this.globalInfo().Resource = LanguageKeys[this.globalInfo().LanguageId];
        });
        this.frmSkill = this.formBuilder.group({
            searchText: [''],
        });
        this.frmLang = this.formBuilder.group({
            LanguageId: [this.globalInfo().CurrentLangId]
        });
        this.frmType = this.formBuilder.group({
            TypeId: [1]
        });
        this.frmLang.controls['LanguageId'].valueChanges.subscribe(val => {

            //this.sharedService.setItem('LanguageId', val);
            this.sharedService.setItem('PreferedLangId', val);
            if (translate.getLangs().find(f => f == this.globalInfo().Resource))
                translate.use(this.globalInfo().Resource);
            else
                translate.use(this.globalInfo().ResourceDefault);
            window.location.reload();
        });
        //super.globalInfo() = this.sharedService.globalInfo();
        setTimeout(() => { this.setTheme(super.globalInfo().ThemeId) }, 100);
    }//constructor ends
    ngOnInit() {
        debugger
        this.getSmsReceivedLog();
        this.geEmailReceivedLog();
        this.settingid = [21, 22, 65, 262];
        this.taxSettingId = [84, 85];



        this.version = require("../../../package.json").version;
        this.companyLogo = "../assets/img/logo/" + super.globalInfo().CompanyId + ".png";
        this.loaderservice.show();
        this.menuService.GetCompanyLogo(super.globalInfo().CompanyId, super.globalInfo().LogoPath).subscribe(res => {


            this.logo = res;
            if (this.logo.attachment)
                this.logo.attachment = this._DomSanitizationService.bypassSecurityTrustUrl('data:image/png;base64,' + this.logo.attachment);
            this.setTheme(super.globalInfo().ThemeId);
            // this.loaderservice.hide();
        }, () => { this.loaderservice.hide(); });
        debugger;
        this.sharedService.getChildPrivileges(super.globalInfo().CompanyId, super.globalInfo().LoginId,
            PageKey.Administration_Setup,
            PageKey.Administration_Setup_SystemSettings)
            .subscribe(s => {
                s.map(m => this.rights = m);
                if (s.length > 0 && this.rights.ViewRights == 1) {
                    this.items =
                        [
                            { label: 'Profile', icon: 'zylog-font-icon zylog-nav_user top-nav-icons' },
                            { label: 'Change Password', icon: 'zylog-font-icon zylog-document top-nav-icons' },
                            { label: 'Settings', icon: 'zylog-font-icon zylog-settings top-nav-icons' },
                            { label: 'Help', icon: 'zylog-font-icon zylog-help top-nav-icons' }
                        ];
                }
                else {
                    this.items =
                        [
                            { label: 'Profile', icon: 'zylog-font-icon zylog-nav_user top-nav-icons' },
                            { label: 'Change Password', icon: 'zylog-font-icon zylog-document top-nav-icons' },
                            { label: 'Help', icon: 'zylog-font-icon zylog-help top-nav-icons' }
                        ];
                }
            }, e => { });

        this.userDisplayName = super.globalInfo().DisplayName;
        this.userEmail = super.globalInfo().DisplayName;
        if (!this.menus || this.menus.length < 1 || (this.menus.length > 0 && !this.menus[0].UiPageName)) {
            this.getMenu();
        }

        //get Default Grid Row Count

        this.menuService.GetCompanyDetails(super.globalInfo().CompanyId).subscribe(res => {
            debugger
            this.menuService.getSystemSettingById(this.globalInfo().CompanyId, this.settingid)
                .subscribe(s => {
                    if (s.length > 0) {
                        localStorage.setItem('gridRowCount', s.find(x => x.SettingId == 21).SettingValue);
                        this.sharedService.gridRowCount = Number(s.find(x => x.SettingId == 21).SettingValue);
                        this.sharedService.innergridRowCount = Number(s.find(x => x.SettingId == 22).SettingValue);
                        this.sharedService.datexRange = Number(s.find(x => x.SettingId == 65).SettingValue);
                        this.istextchat = s.find(x => x.SettingId == 262).SettingValue == '0' ? false : true;
                    }
                }, () => { this.sharedService.gridRowCount = 25; this.sharedService.innergridRowCount = 10; this.sharedService.datexRange = 60; });


            // this.CompanyUniqueId = super.globalInfo().CompanyId.toString();
            this.CompanyUniqueId = res.UniqueId;
            this.sharedService.isEnablePreferredVendor = res.EnablePreferVendorForCustomer == 1 ? true : false;
            this.sharedService.isEnablePreferredVendorEmit.emit({
                isEnablePreferVendor: this.sharedService.isEnablePreferredVendor
            });
            this.sharedService.isEnableTax = res.IsTaxEnabled == 1 ? true : false;
            this.sharedService.TaxEnable.emit({
                Tax: res.IsTaxEnabled == 1 ? true : false
            });
            this.IsQUoteEnabled = res.IsQuoteEnabled == 1 ? true : false;;
            if (res.IsQuoteEnabled == 1) {

                this.IsQUoteEnabled = true;
            }
            else {

                this.IsQUoteEnabled = false;
            }
            this.sharedService.isEnablePolygonRegion = res.IsPolygonRegion == 1 ? true : false;
            this.sharedService.isEnablePolygonRegionEmit.emit({
                isEnablePolygonRegion: this.sharedService.isEnablePolygonRegion
            });
        });
        //Added by Anvardeen Batcha  -- Tax implementation
        // this.menuService.getEnableTax(super.globalInfo().CompanyId).subscribe(res => {
        //     debugger

        //     this.sharedService.isEnableTax = res == 1 ? true : false;
        //     this.sharedService.TaxEnable.emit({
        //         Tax: res == 1 ? true : false
        //     });
        // });


        // this.menuService.QuoteEnabled(super.globalInfo().CompanyId).subscribe(res => {debugger

        //     console.log(res);
        //     this.IsQUoteEnabled = res
        //     if (res == 1) {

        //      this.IsQUoteEnabled = true;
        //      }
        //     else {

        //         this.IsQUoteEnabled = false;
        //     }
        // });

        // this.menuService.GetEnablePreferredVendor(super.globalInfo().CompanyId).subscribe(res => {
        //     debugger
        //     this.sharedService.isEnablePreferredVendor = res == 1 ? true : false;
        //     this.sharedService.isEnablePreferredVendorEmit.emit({
        //         isEnablePreferVendor: this.sharedService.isEnablePreferredVendor
        //     });
        // });

        //Added by Rajesh kanna B    

        // this.menuService.getEnablePolygonRegion(super.globalInfo().CompanyId).subscribe(res => {
        //     this.sharedService.isEnablePolygonRegion = res == 1 ? true : false;
        //     this.sharedService.isEnablePolygonRegionEmit.emit({
        //         isEnablePolygonRegion: this.sharedService.isEnablePolygonRegion
        //     });
        // });


        this.menuService.getSystemSettingById(this.globalInfo().CompanyId, [35, 94, 71, 117, 116, 152, 168])
            .subscribe(s => {
                debugger
                if (s.length > 0) {
                    this.woName = s.find(x => x.SettingId == 35).SettingValue + ' #';
                    this.pmwoName = s.find(x => x.SettingId == 94).SettingValue + ' #';
                    this.woStr = s.find(x => x.SettingId == 35).SettingValue;
                    this.pmwoStr = s.find(x => x.SettingId == 94).SettingValue;
                    this.qoStr = s.find(x => x.SettingId == 168).SettingValue;
                    this.sharedService.distance = Distance[s.find(x => x.SettingId == 71).SettingValue];
                    this.sharedService.dashboardDateRange = Number(s.find(x => x.SettingId == 116).SettingValue);
                    this.sharedService.reportDateRange = Number(s.find(x => x.SettingId == 117).SettingValue);
                    let allowchkSave = s.find(x => x.SettingId == 152);
                    console.log(s);
                    this.sharedService.distanceemit.emit({
                        distance: this.sharedService.distance
                    });

                    this.sharedService.reportDateRangeemit.emit({
                        reportDateRange: this.sharedService.reportDateRange
                    });
                    this.sharedService.emitSystemSettings.emit({
                        reportDateRange: this.sharedService.reportDateRange,
                        distance: this.sharedService.distance,
                        dashboardDateRange: this.sharedService.dashboardDateRange,

                        //added by nagarjuna
                        gridRowCount: this.sharedService.gridRowCount,
                    }
                    );

                    if (this.woName == this.pmwoName) {
                        debugger
                        this.isSame = true;
                        this.frmType = this.formBuilder.group({
                            TypeId: [5]
                        });
                    }



                }
            });




        //Added by Anvardeen Batcha  -- Tax implementation

        // WO/Job Search ddl  function starts
        this.frmType.controls["TypeId"].valueChanges.subscribe(value => {
            if (value == 3 || value == 1 || value == 4 || value == 6)
                this.type = false;
            else
                this.type = true;

            this.frmSkill.controls["searchText"].setValue("");
        }); // WO/Job Search ddl  function starts 
        this.menuService.getSystemSettingById(this.globalInfo().CompanyId, this.taxSettingId)
            .subscribe(s => {
                if (s.length > 0) {
                    var taxTypeId = Number(s.find(x => x.SettingId == 84).SettingValue);
                    var taxGroupId = Number(s.find(x => x.SettingId == 85).SettingValue);
                    if (taxTypeId == 1) {
                        this.sharedService.isDefaultTax = "Tax," + taxGroupId;
                    }
                    else if (taxTypeId == 2) {
                        this.sharedService.isDefaultTax = "TG," + taxGroupId;
                    }
                    else {
                        this.sharedService.isDefaultTax = "0";
                    }

                }
            }, () => { this.sharedService.isDefaultTax = "0"; });
        //     this.getSMSCount();

        // this.getSMSCount();
        // this.interval = setInterval(() => {
        //     this.getSmsReceivedLog();
        //     this.geEmailReceivedLog();          
        //     this.getSMSCount();
        // }, 900000);

        this.getEmailCount();
        this.getSMSCount();
        this.interval = setInterval(() => {
            this.getSMSCount();
            this.getSmsReceivedLog();
        }, 600000);
        this.interval = setInterval(() => {
            this.getEmailCount();
            this.geEmailReceivedLog();
        }, 600000);

        this.sharedService.emailJob.subscribe(data => {
            this.EmailJob = data.key;
            this.openEmailpopup = data.value;
        });

        // this.sharedService.quoteemailJob.subscribe(data => {debugger
        //     this.EmailJob = data.key;
        //     this.openQuoteEmailpopup = data.value;
        // });
    }//ngInit ends


    getEmailCount() {
        this.woService.getSMSCount(super.globalInfo().CompanyId, super.globalInfo().MaxRoleGroup, super.globalInfo().VendorId, super.globalInfo().LoginId, 2).subscribe(s => {
            this.ReadedEmailCount = s;

        });
    }
    geEmailReceivedLog() {

        this.woService.getSmsReceivedLog(this.globalInfo().CompanyId, this.globalInfo().MaxRoleGroup, this.globalInfo().VendorId, this.globalInfo().LoginId, this.globalInfo().TimeZoneId, 2).subscribe(resp => {

            this.emaillogReceived = resp;

            this.emaillogReceived.map(m => {
                m.RecvdDateShort = this.datePipe.transform(m.RecvdDate, 'shortDate');
                m.RecvdTime = this.datePipe.transform(m.RecvdDate, 'shortTime');
                //  m.RecvdDate = this.datePipe.transform(m.RecvdDate, 'short');
                m.Notification = 2;

                return m
            });
        }
        );
    }
    getSmsReceivedLog() {

        this.woService.getSmsReceivedLog(this.globalInfo().CompanyId, this.globalInfo().MaxRoleGroup, this.globalInfo().VendorId, this.globalInfo().LoginId, this.globalInfo().TimeZoneId, 1).subscribe(resp => {

            this.smslogReceived = resp;

            this.smslogReceived.map(m => {
                m.imageStatus = m.Filepath == "" ? false : true;

                m.RecvdDateShort = this.datePipe.transform(m.RecvdDate, 'shortDate');
                m.RecvdTime = this.datePipe.transform(m.RecvdDate, 'shortTime');
                m.Notification = 1;
                return m
            });
        }
        );
    }

    getSMSCount() {

        this.woService.getSMSCount(super.globalInfo().CompanyId, super.globalInfo().MaxRoleGroup, super.globalInfo().VendorId, super.globalInfo().LoginId, 1).subscribe(s => {
            this.ReadedCount = s;
        });
    }

    ngAfterViewInit() {
        super.GoogleMapScript();
        this.passwordLicenseAlert();
        this.loadScripts();
    }
    ngOnDestroy() {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove("default");
    }
    private loadScripts() {
        // You can load multiple scripts by just providing the key as argument into load method of the service    


        this.sharedService.loadDynamicScript()
            .load('datamaps-world', 'datamaps-all', 'drag-drop-touch', 'powerbi', 'jsts', 'd3', 'topojson', 'jspdf-autotable')
            .then(() => {
            }).catch(error => console.log(error));
        if (this.globalInfo().MapId == '1') {
            this.sharedService.loadDynamicScript()
                .load('bing-map')
                .then(() => {
                }).catch(error => console.log(error));
        }
    }
    getMenu() {

        this.loaderservice.show();
        this.menuService.getMenuItems(super.globalInfo().CompanyId, super.globalInfo().LoginId, this.globalInfo().CurrentLangId)
            .subscribe(res => {

                if (res.length < 1 || this.menus.filter(x => x.ParentMenuId == 0).length > 0) {
                    this.menuService.getMenuItems(super.globalInfo().CompanyId, super.globalInfo().LoginId, this.globalInfo().LanguageId)
                        .subscribe(res => {
                            this.menus = res.map(s => {
                                s.ActClass = s.MenuName == 'Home' ? 'active' : '';
                                s.Icon = s.Icon == null ? 'zylog-mmenu_home' : s.Icon;
                                return s;
                            });
                        });
                }
                else {
                    this.menus = res.map(s => {
                        s.ActClass = s.MenuName == 'Home' ? 'active' : '';
                        s.Icon = s.Icon == null ? 'zylog-mmenu_home' : s.Icon;
                        return s;
                    });
                }

                //Below code added for if web api reset menu not exists
                if (this.menus.length == 0) {
                    // this.communicationService.alertMessage({ severity: 'error', summary: 'Server Error', detail: 'The configuration settings for the user or the organization are incomplete. This will forbid you from using the application until rectified. Please contact your administrator' });
                    this.loaderservice.hide();
                    return;
                }
                // this.menus = result;
                this.selectedMenu = this.menus[0];
                this.loaderservice.hide();
                if (!this.sharedService.isAccessDenied) {
                    //HomePageLoaded - After Login First Time Only Load Home Page Configure based on Settings.
                    if (!localStorage.getItem("HomePageLoaded") && (this.globalInfo().HomePageId == 43 || this.globalInfo().HomePageId == 44))
                        localStorage.setItem("HomePageLoaded", '0');
                    if (localStorage.getItem("HomePageLoaded") == "0") {
                        if (this.globalInfo().HomePageId == 43)
                            this.router.navigate(['/customview/ManageTechnicianJobs']);
                        else if (this.globalInfo().HomePageId == 44)
                            this.router.navigate(['/dispatch/dispatchboard']);
                        localStorage.setItem("HomePageLoaded", '1');
                    }
                }
                else
                    this.sharedService.isAccessDenied = false;
                this.loaderservice.hide();
            }, error => {
                console.log(error);
                this.loaderservice.hide();
            });//Menu subscribe ends


    }
    setTheme(ThemeId) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove("pink");
        body.classList.remove("gray");
        body.classList.remove("lgray");
        body.classList.remove("dblue");
        body.classList.remove("dgreen-gray");
        switch (ThemeId) {
            case Theme.Blue.toString():
                body.classList.add("default");
                break;
            case Theme.Pink.toString():
                body.classList.add("pink");
                break;
            case Theme.Gray.toString():
                body.classList.add("gray");
                break;
            case Theme.LightGray.toString():
                body.classList.add("lgray");
                break;
            case Theme.DarkBlue.toString():
                body.classList.add("dblue");
                break;
            case Theme.DarkGreen.toString():
                body.classList.add("dgreen-gray");
                break;
            default:
                body.classList.add("default");
                break;
        }
    }
    // getSMSCount() {

    // }
    detailedMenuClick(type?: number) {
        if (type == 1)
            this.openEmailpopup = false;
        this.detailedMenu = !this.detailedMenu;
        let body = document.getElementsByTagName('body')[0];
        if (this.detailedMenu) {
            body.classList.add("no-scroll");
            body.classList.add("ovrdesk-hide");
            // body.classList.add("no-scroll ovrdesk-hide");
        }
        else {
            body.classList.remove("no-scroll");
            body.classList.remove("ovrdesk-hide");
            // body.classList.remove("no-scroll ovrdesk-hide");
        }
    }
    passwordLicenseAlert() {
        let passwordAlert, licenseAlert;
        this.translate.get(['LICENSEEXPIRES', 'LICENSEEXPIRESTODAY', 'PASSWORDEXPIRES', 'PASSWORDEXPIRESTODAY'],
            { licVal: this.globalInfo().LicenseExpired, passVal: this.globalInfo().PasswordExpired }).subscribe(s => {

                if (this.globalInfo().PasswordExpired && +this.globalInfo().PasswordExpired > -1) {
                    if (+this.globalInfo().PasswordExpired == 0)
                        passwordAlert = s.PASSWORDEXPIRESTODAY;
                    else if (+this.globalInfo().PasswordExpired > 0)
                        passwordAlert = s.PASSWORDEXPIRES;
                    this.sharedService.notification.emit({
                        severity: 'warn',
                        summary: 'Alert',
                        detail: passwordAlert
                    });
                }

                if (this.globalInfo().LicenseExpired && +this.globalInfo().PasswordExpired > -1) {
                    if (+this.globalInfo().LicenseExpired == 0)
                        licenseAlert = s.LICENSEEXPIRESTODAY
                    else if (+this.globalInfo().LicenseExpired > 0)
                        licenseAlert = s.LICENSEEXPIRES
                    this.sharedService.notification.emit({
                        severity: 'warn',
                        summary: 'Alert',
                        detail: licenseAlert
                    });
                }
            });
    }
    logout() {

        this.sharedService.RemoveChildPrivilegesCache().subscribe(s => {
            console.log(s ? 'Access Removed' : 'Access not removed / not in cahce');
            this.sharedService.resetGlobalInfo();
            this.authService.signOut();
        });
    }

    Route(value: UserInfo) {
        this.openEmailpopup = false;
        this.detailedMenu = false;
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove("no-scroll");
        body.classList.remove("ovrdesk-hide");
        if (value.label == 'Profile')
            this.router.navigate(['/admin/edituser/' + super.globalInfo().LoginId + '/' + super.globalInfo().CompanyId + '/' + super.globalInfo().IsLatLonBased]);

        else if (value.label == 'Settings')
            this.router.navigate(['/admin/systemsettings/']);
        else if (value.label == 'Change Password')
            this.router.navigate(['/account/changepassword/']);
        else if (value.label == 'Help')
            this.router.navigate(['/reports/dashboards/810']);
    }



    quickSearchClick() {
        debugger
        this.detailedMenu = false;
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove("no-scroll");
        body.classList.remove("ovrdesk-hide");

        var value = this.frmSkill.controls["searchText"].value;
        var ddid = this.frmType.controls['TypeId'].value;
        value = ddid == 3 ? encodeURIComponent(value.toLowerCase()) : value;
        if (ddid == 1 || ddid == 5) {
            if (isNaN(value))// with WOrderOrder Number like WO,SO, IF Pass string value return true, otherwise false (isNan())            
                value = value;
            else
                value = this.woStr + value;


        }
        else if (ddid == 4) {
            if (isNaN(value))// with WOrderOrder Number like WO,SO, IF Pass string value return true, otherwise false (isNan())            
                value = value;
            else
                value = this.pmwoStr + value;
        }
        else if (ddid == 6) {
            if (isNaN(value))
                value = value;
            else
                value = this.qoStr + value;
        }
        // if (value.startsWith('wo')) {
        if (value != '') {
            debugger
            var id = this.frmType.controls['TypeId'].value;
            if (id == 6) {
                debugger

                this.woService.Quotesearch(super.globalInfo().CompanyId, value).subscribe(s => {
                    debugger
                    var SearchQuote: SearchQuote = s;
                    this.detailedMenu = false;
                    if (SearchQuote && SearchQuote.QOJobId) {

                        if (SearchQuote != null && id == 6) {
                            this.router.navigate(['/quote/quotedetails/' + SearchQuote.QuoteOrderId + "/" + SearchQuote.CustomerId], { queryParams: { trackId: Math.random() } });

                        }
                        else {
                            debugger
                            this.sharedService.notification.emit({
                                severity: "error",
                                summary: this.translate.instant("THEQUOTE")
                            });
                        }
                        this.frmSkill.controls["searchText"].setValue("");

                    }

                    else {
                        var prefix = '';
                        if (ddid == 6)
                            prefix = this.translate.instant("QONO");
                        this.sharedService.notification.emit({
                            severity: "error",
                            summary: prefix + ' ' + this.translate.instant("DOESNOTEXISTS")
                        });
                    }

                });
            }
            this.woService.checkWorkOrderExist(super.globalInfo().CompanyId, value, super.globalInfo().IsTech, super.globalInfo().LoginId, super.globalInfo().MaxRoleGroup, super.globalInfo().VendorId, id, super.globalInfo().IsManager).subscribe(s => {
                debugger
                var searchWorkOrder: SearchWorkOrder = s;
                this.detailedMenu = false;

                if (searchWorkOrder && searchWorkOrder.WoJobId) {
                    this.woService.CheckInHouseJob(super.globalInfo().CompanyId, searchWorkOrder.WoJobId).subscribe(x => {
                        this.ifinhouse = x;
                        debugger;
                        // this.router.navigate(['/technician/inhouseJobsDetails/' + searchWorkOrder.WorkOrderId + "/" + searchWorkOrder.CustomerId], { queryParams: { trackId: Math.random() } });
                        if (searchWorkOrder != null && (id == 1 || id == 3 || id == 4 || id == 5))
                            this.router.navigate(['/workorder/wodetails/' + searchWorkOrder.WorkOrderId + "/" + searchWorkOrder.CustomerId], { queryParams: { trackId: Math.random() } });
                        else if (searchWorkOrder != null && id == 2) {
                            if (this.ifinhouse == 1)
                                this.router.navigate(['/technician/inhouseJobsDetails/' + searchWorkOrder.WoJobId + '/' + searchWorkOrder.WoCategoryId + '/' + searchWorkOrder.WorkOrderId + '/' + searchWorkOrder.TechId + '/' + searchWorkOrder.WoNumber + '/1'], { queryParams: { trackId: Math.random() } });
                            else if (this.ifinhouse == 0)
                                this.router.navigate(['/technician/technicianadetails/' + searchWorkOrder.WoJobId + '/' + searchWorkOrder.WoCategoryId + '/' + searchWorkOrder.WorkOrderId + '/' + (searchWorkOrder.TechId == null ? 0 : searchWorkOrder.TechId) + '/' + searchWorkOrder.WoNumber], { queryParams: { trackId: Math.random() } });
                            else
                                this.router.navigate(['/home'], { queryParams: { WoJobId: searchWorkOrder.WoJobId, WoCategoryId: searchWorkOrder.WoCategoryId, WorkOrderId: searchWorkOrder.WorkOrderId, TechId: (searchWorkOrder.TechId == null ? 0 : searchWorkOrder.TechId), WoNumber: searchWorkOrder.WoNumber } });
                        }

                        else if (searchWorkOrder == null && (id == 1 || id == 3 || id == 4 || id == 5)) {
                            this.sharedService.notification.emit({
                                severity: "error",
                                summary: this.translate.instant("WONOTAVAILABLE")
                            });
                        }
                        else {
                            if (id == 1 || id == 3 || id == 4 || id == 5 || id != 6) {
                                this.sharedService.notification.emit({
                                    severity: "error",
                                    summary: this.translate.instant("JOBNOTAVAILABLE")
                                });
                            }
                        }
                        this.frmSkill.controls["searchText"].setValue("");
                    });
                }
                else if (searchWorkOrder) {
                    if (searchWorkOrder != null && (id == 1 || id == 3 || id == 4 || id == 5))
                    this.router.navigate(['/workorder/wodetails/' + searchWorkOrder.WorkOrderId + "/" + searchWorkOrder.CustomerId], { queryParams: { trackId: Math.random() } });
             
                }
                else {
                    debugger
                    var prefix = '';
                    if (ddid == 1 || ddid == 5)
                        prefix = this.woName;
                    else if (ddid == 4)
                        prefix = this.pmwoName;
                    else if (ddid == 2)
                        prefix = this.translate.instant("JOBNO");
                    else if (ddid == 3)
                        prefix = this.translate.instant("REFNO");
                    if (ddid != 6 || ddid == 1 || ddid == 5 || ddid == 4 || ddid == 2 || ddid == 3) {



                        this.sharedService.notification.emit({
                            severity: "error",
                            summary: prefix + ' ' + this.translate.instant("DOESNOTEXISTS")
                        });
                    }
                }
            });
        }


    }

    openReceivedSMS() {

        if (this.detailedMenu == true)
            this.detailedMenu = false;
        this.openEmailpopup = false;
        this.IsOpensms = true;
    }
    closepopup(success: any) {

        if (success == false) {
            this.getSMSCount();
            this.IsOpensms = false;
        }
    }
    openNotification(data: any) {

        this.smsmsg = data.smslog;
        if (this.detailedMenu == true)
            this.detailedMenu = false;
        this.IsNotification = true;
    }


    closeNotification(success: any) {

        if (success == false) {
            this.IsNotification = false;
        }

    }

    openSMSLog() {
        this.done.emit(false);
        this.router.navigate(['/reports/smslogreport']);

    }
    openEmailLog() {
        this.done.emit(false);
        this.router.navigate(['/reports/emailogreport']);

    }

    get menus() {
        return LayoutComponent._menus;
    }
    set menus(value) {
        LayoutComponent._menus = value;
    }
    showTextChat: string = 'none';
    showTextChat1: string = 'none';
    navigateToTextChat() {
        this.showTextChat = this.showTextChat == 'block' ? 'none' : 'block';
        // this.router.navigate(['/admin/textchat']);
    }
    fpnavigateToTextChat() {
        this.showTextChat1 = this.showTextChat1 == 'block' ? 'none' : 'block';
    }
    openNotificationForsnslog(data: any) {
        var ss = data.success
        this.smsmsg = data;
        if (this.detailedMenu == true)
            this.detailedMenu = false;
        this.IsNotification = true;
        this.open.emit({ success: true, smslog: this.smsmsg });
    }
    GetChatCount(chatCount) {
        this.chatCount = chatCount;
    }

}   
